import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { bonuses, type BonusAccent } from '../data/system';
const accentStyles: Record<BonusAccent, {
  badge: string;
  dot: string;
}> = {
  electric: {
    badge: 'bg-electric/10 text-electric-deep',
    dot: 'bg-electric'
  },
  perf: {
    badge: 'bg-perf/15 text-perf-deep',
    dot: 'bg-perf'
  },
  ember: {
    badge: 'bg-ember/20 text-ember-deep',
    dot: 'bg-ember'
  },
  aqua: {
    badge: 'bg-aqua/15 text-aqua-deep',
    dot: 'bg-aqua'
  }
};
export function Bonuses() {
  return <section aria-label="Bonus inclusi" className="bg-white" data-id="element-18" data-mp="3o1lf0qlfzjix">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-19" data-mp="3o369yhbo54hb">
        <div className="text-center" data-id="element-20" data-mp="3t2sn6qrhykq4">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-ember/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-ember-deep" data-id="element-21" data-mp="1m9qjpljhtrmv">
            Solo per l'offerta attuale
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-6xl" data-id="element-22" data-mp="3idmytxc3p7g2">
            4 bonus inclusi
          </h2>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-23" data-mp="3r6qiindcagj5">
          {bonuses.map((b, i) => {
          const a = accentStyles[b.accent];
          return <motion.article key={b.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-warm p-5 sm:p-6" data-id="element-24" data-mp="3n67ocmnz4yds" data-mpi={i}>
                <div className="flex gap-4 sm:gap-5" data-id="element-25" data-mp="33ge4curi3nk4">
                  <img src={b.cover} alt={`Copertina di ${b.title}`} width={1122} height={1402} loading="lazy" decoding="async" className="h-auto w-24 shrink-0 self-start drop-shadow-[0_12px_16px_rgba(16,28,44,0.25)] sm:w-32" data-id="element-26" data-mp="nprk1895ipl5" />
                  <div className="min-w-0 flex-1" data-id="element-27" data-mp="3chv39kmwh2k0">
                    <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-28" data-mp="3cl95msvkdbrg">
                      <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold', a.badge)} data-id="element-29" data-mp="3hk404s2w8ore">
                        <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-30" data-mp="3qixu0aoub119" /> Bonus {b.n}
                      </span>
                      <span className="whitespace-nowrap text-sm font-bold" data-id="element-31" data-mp="2ttq30n5gbzpy">
                        <span className="text-navy/40 line-through" data-id="element-32" data-mp="2xt8r1rskkqx0">{b.price}</span>{' '}
                        <span className="text-perf-deep" data-id="element-33" data-mp="32sl9m0cerbts">{b.included}</span>
                      </span>
                    </div>
                    <h3 className="mt-3 font-display text-xl font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-34" data-mp="37klg6bmzh2zc">
                      {b.title}
                    </h3>
                    <p className="mt-1.5 text-sm font-semibold leading-snug text-navy/65" data-id="element-35" data-mp="2f2qypobnfxc6">{b.subtitle}</p>
                  </div>
                </div>
                <div className="mt-4 space-y-2 text-sm leading-relaxed text-navy/70" data-id="element-36" data-mp="27hx4ix6mru2g">
                  {b.desc.map(d => <p key={d} data-id="element-37" data-mp="22j3szaawmd4x">{d}</p>)}
                </div>
                <ul className="mt-auto flex flex-wrap gap-1.5 pt-5" data-id="element-38" data-mp="1xkiq1349pfcs">
                  {b.tags.map(t => <li key={t} className="inline-flex items-center gap-1.5 rounded-md border border-navy/10 bg-white px-2 py-1 text-xs font-medium text-navy/75" data-id="element-39" data-mp="1tj6xopu0eg0w">
                      <span className={cn('h-1.5 w-1.5 rounded-full', a.dot)} aria-hidden="true" data-id="element-40" data-mp="1jufcr1nd8vzh" />
                      {t}
                    </li>)}
                </ul>
              </motion.article>;
        })}
        </div>

        <div className="mt-10 rounded-2xl bg-navy px-6 py-8 text-center text-white sm:px-10" data-id="element-41" data-mp="19wrdpziq92bi">
          <p className="font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-42" data-mp="15v5ulwflnrsv">
            4 strumenti pratici <span className="text-perf" data-id="element-43" data-mp="10wm7hsp9s9yx">inclusi</span> nell'offerta attuale
          </p>
          <p className="mt-2 text-sm text-white/65" data-id="element-44" data-mp="30xkehiql38rt">
            Valore complessivo indicativo dei quattro bonus: <span className="line-through" data-id="element-45" data-mp="34zntghcgovhu">120 €</span>
          </p>
          <p className="mt-6 text-sm text-white/70" data-id="element-46" data-mp="2r80w0e6s9gxh">
            Con IL SISTEMA TRIATHLON FULL DISTANCE™ non ricevi soltanto il metodo principale. Ricevi anche
            strumenti progettati per aiutarti a:
          </p>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-display text-2xl font-bold uppercase tracking-wide" data-id="element-47" data-mp="2h9bn3awv76td">
            <span data-id="element-48" data-mp="2ma7s5rsycz0d">Pianificare</span>
            <span className="text-electric" aria-hidden="true" data-id="element-49" data-mp="289es6rjvtbpv">→</span>
            <span data-id="element-50" data-mp="28b834j1j2i3o">Alimentarti</span>
            <span className="text-electric" aria-hidden="true" data-id="element-51" data-mp="2d7q2f3e39o8m">→</span>
            <span data-id="element-52" data-mp="2da2u489nfcyv">Prepararti</span>
            <span className="text-electric" aria-hidden="true" data-id="element-53" data-mp="6h8opot3zkmr">→</span>
            <span data-id="element-54" data-mp="bgv4a4wetcyq">Monitorare</span>
          </p>
          <p className="mt-4 text-sm text-white/55" data-id="element-55" data-mp="bfk1a7asg98o">Tutto in un unico pacchetto digitale SIGMA SMART™.</p>
        </div>
      </div>
    </section>;
}